import { render, staticRenderFns } from "./ResponsiveDesignLayer.vue?vue&type=template&id=20093bc6&scoped=true"
import script from "./ResponsiveDesignLayer.vue?vue&type=script&lang=js"
export * from "./ResponsiveDesignLayer.vue?vue&type=script&lang=js"
import style0 from "./ResponsiveDesignLayer.vue?vue&type=style&index=0&id=20093bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20093bc6",
  null
  
)

export default component.exports